import type { StatBlock, StatId } from '../domain/stats.ts';
import { STAT_IDS } from '../domain/stats.ts';

/**
 * RULE DCC-STAT-LAYER-001 - Rules for Survival p.11.
 * Unenhanced = the crawler's own score (starting Stats, Stat potions,
 * transformations, and Stat Points from levelling).
 * Enhanced   = Unenhanced plus bonuses from gear, Spells, Buffs and other sources.
 *
 * This is the seam where equipment/Buff modifiers will plug in later. Today no
 * such sources are implemented, so the list is normally empty and Enhanced
 * equals Unenhanced.
 */
export interface StatModifierSource {
  /** Where the bonus comes from, for display in the breakdown. */
  label: string;
  stat: StatId;
  amount: number;
}

export function resolveEnhancedStats(
  unenhanced: StatBlock,
  sources: readonly StatModifierSource[] = [],
): StatBlock {
  const result: StatBlock = { ...unenhanced };
  for (const source of sources) {
    if (!(STAT_IDS as readonly string[]).includes(source.stat)) {
      throw new Error(`Unknown Stat in modifier source: ${source.stat}`);
    }
    result[source.stat] += source.amount;
  }
  return result;
}
